// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ClaimV1PlaceOrderDefaultResponse {
    static getAttributeTypeMap() {
        return ClaimV1PlaceOrderDefaultResponse.attributeTypeMap;
    }
}
ClaimV1PlaceOrderDefaultResponse.discriminator = undefined;
ClaimV1PlaceOrderDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "IPlaceOrderResponseModel"
    }
];
//# sourceMappingURL=claimV1PlaceOrderDefaultResponse.js.map